import Backbone from 'backbone';
import templateConfig from '../config/templateIcons.js';

export default Backbone.Model.extend({
  defaults: {
    template_id: '',
    name: '',
    is_active: 0,
    control_id: '',
    keywords: '',
    group: '',
    image: '',
    description: '',
    html: '',
    css: '',
    js: ''
  },

  validate: function(attrs) {
    var errors = [];
    if (!attrs.name) {
      errors.push({ name: 'name', message: 'Please fill name field.' });
    }
    if (!attrs.description) {
      errors.push({
        name: 'description',
        message: 'Please fill description field.'
      });
    }
    if (!attrs.keywords) {
      errors.push({ name: 'keywords', message: 'Please fill keywords field.' });
    }
    if (!attrs.group) {
      errors.push({ name: 'group', message: 'Please select group.' });
    }
    if (attrs.image.indexOf(templateConfig.defaulticon) > -1) {
      errors.push({ name: 'image', message: 'Please select an icon.' });
    }
    return errors.length > 0 ? errors : false;
  }
});
